export default __webpack_public_path__ + "static/media/morty.34c60ae7.svg";